import React from 'react';
import { Link } from 'react-router-dom';
import FooterMain from 'components/layout/footer/FooterMain';
import HeaderNavigation from 'components/layout/header/HeaderNavigation';
import styles from 'styles/components/MaintenanceUnavailable.module.sass';
import { formatLocalTime } from './format';
import { MaintenanceNotice } from './types';

interface UnavailableViewProps {
  blocking: readonly MaintenanceNotice[];
  expectedBackAt: string | null;
  /** Area being blocked; the home link is hidden when home itself is the blocked area. */
  area?: string | undefined;
  onRetry: () => void;
}

/**
 * Replaces a blocked page's content while keeping the site header and footer,
 * so visitors can still go elsewhere.
 */
const UnavailableView: React.FC<UnavailableViewProps> = ({
  blocking,
  expectedBackAt,
  area,
  onRetry,
}) => {
  const when = expectedBackAt ? formatLocalTime(expectedBackAt) : '';

  return (
    <div className={styles['unavailable-page']}>
      <div className={styles['header-backdrop']}>
        <HeaderNavigation />
      </div>
      <main className={styles['content']}>
        <div role="alert" className={styles['card']}>
          {blocking.map((notice) => (
            <div key={`${notice.area ?? ''}|${notice.title}|${notice.startsAt}`}>
              <h1 className={styles['title']}>{notice.title}</h1>
              {notice.message && <p className={styles['message']}>{notice.message}</p>}
            </div>
          ))}
          <p className={styles['eta']}>
            {when ? `Expected back around ${when}` : 'We expect to be back shortly'}
          </p>
          <div className={styles['actions']}>
            {area !== 'website' && (
              <Link to="/" className={styles['home-link']}>
                Back to home
              </Link>
            )}
            <button type="button" className={styles['retry-button']} onClick={onRetry}>
              Check again
            </button>
          </div>
        </div>
      </main>
      <FooterMain />
    </div>
  );
};

export default UnavailableView;
